import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as changeImpact from '../change-impact'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: changeImpact.RESOURCE.payload.dimension.partialId,
      partialId: changeImpact.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Degree of change for this change impact.',
    isOptional: true,
    name: 'Degree of Change',
    partialId: PartialId.Standard.create('degree_of_change'),
    type: {
      enumId: core.dms.models.Enum.Id.from(
        enums.changeImpactRank.RESOURCE.payload,
      ),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
